module.exports = __webpack_public_path__ + "img/failure.343c8b56.jpg";